import { findIndex } from "lodash"
import { produce } from "immer"
import createActions from "helpers/actionCreator"

const EMPTY_ARRAY = []

export const { Types, Creators } = createActions("ompnt/app/recentInstruments", {
  updateRecentInstrument: ["updatedInstrument"],
  setRecentInstruments: ["recentInstruments"],
})

const initialState = EMPTY_ARRAY

function updateRecentInstrument(draft, action) {
  const { updatedInstrument } = action
  const indexToUpdate = findIndex(draft, ({ id }) => id === updatedInstrument.id)

  if (indexToUpdate > -1) {
    draft.splice(indexToUpdate, 1)
  }

  draft.unshift(updatedInstrument)

  draft.forEach((instrument, index) => {
    instrument.order = index + 1
  })
}

export default function recentInstrumentsReducer(state = initialState, action) {
  switch (action.type) {
    case Types.SET_RECENT_INSTRUMENTS:
      return action.recentInstruments

    case Types.UPDATE_RECENT_INSTRUMENT:
      return produce(state, draft => {
        updateRecentInstrument(draft, action)
      })

    default:
      return state
  }
}
